import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/user-161.png'
import _imports_1 from '@/assets/images/user-162.png'
import _imports_2 from '@/assets/images/user-163.png'
import _imports_3 from '@/assets/images/user-164.png'
import _imports_4 from '@/assets/images/user-165.png'


const _hoisted_1 = { class: "card custom-shadow rounded-3 bg-white border mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "custom-padding-30" }, [
      _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 gap-sm-3 pb-4 mb-2" }, [
        _createElementVNode("h3", { class: "mb-0 fw-semibold" }, "Agents Performance Overview"),
        _createElementVNode("div", {
          class: "dropdown select-dropdown without-border position-relative",
          style: {"right":"-5px"}
        }, [
          _createElementVNode("button", {
            class: "dropdown-toggle bg-transparent border text-body rounded-2",
            style: {"padding-right":"20px"},
            role: "button",
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false"
          }, " Last Month "),
          _createElementVNode("ul", { class: "dropdown-menu dropdown-menu-end bg-white border-0 box-shadow py-3" }, [
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Today ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last Week ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last Month ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last Year ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", { class: "row mb-4 pb-2" }, [
        _createElementVNode("div", { class: "col-lg-12" }, [
          _createElementVNode("span", { class: "d-block mb-3 fw-normal" }, "Top Performing Agent")
        ]),
        _createElementVNode("div", { class: "col-sm-4" }, [
          _createElementVNode("div", { class: "d-flex align-items-center" }, [
            _createElementVNode("div", { class: "flex-shrink-0 position-relative z-1" }, [
              _createElementVNode("img", {
                src: _imports_0,
                class: "rounded-2",
                alt: "user"
              }),
              _createElementVNode("span", {
                class: "bg-success rounded-circle d-inline-block position-absolute top-50 start-100 translate-middle",
                style: {"width":"8px","height":"8px"}
              })
            ]),
            _createElementVNode("div", { class: "flex-grow-1 ms-10" }, [
              _createElementVNode("h4", { class: "fs-14 fw-semibold mb-0" }, "John Smith"),
              _createElementVNode("span", { class: "text-secondary" }, "380 Calls")
            ])
          ])
        ]),
        _createElementVNode("div", { class: "col-sm-8 mt-2 mt-sm-0" }, [
          _createElementVNode("div", { class: "ms-sm-4 ps-sm-3" }, [
            _createElementVNode("div", { class: "d-flex justify-content-between align-items-center mb-2" }, [
              _createElementVNode("span", null, "Customer Satisfaction (CSAT)"),
              _createElementVNode("span", null, "92%")
            ]),
            _createElementVNode("div", {
              class: "progress bg-border-color",
              role: "progressbar",
              "aria-label": "Success example",
              "aria-valuenow": "92",
              "aria-valuemin": "0",
              "aria-valuemax": "100",
              style: {"height":"6px"}
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-success-60 rounded-pill",
                style: {"width":"92%","height":"6px"}
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", { class: "default-table-area style-three agents-performance-overview" }, [
        _createElementVNode("div", { class: "table-responsive" }, [
          _createElementVNode("table", { class: "table align-middle border-0" }, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "flex-shrink-0 position-relative z-1" }, [
                      _createElementVNode("img", {
                        src: _imports_1,
                        class: "rounded-2",
                        alt: "user"
                      }),
                      _createElementVNode("span", {
                        class: "bg-success rounded-circle d-inline-block position-absolute top-50 start-100 translate-middle",
                        style: {"width":"8px","height":"8px"}
                      })
                    ]),
                    _createElementVNode("div", { class: "flex-grow-1 ms-10" }, [
                      _createElementVNode("h4", { class: "fs-14 fw-medium mb-0" }, "Sarah Davis"),
                      _createElementVNode("span", { class: "text-secondary" }, "65 Calls")
                    ])
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "text-body" }, "Avg. Call Duration"),
                  _createElementVNode("span", { class: "fw-medium d-block" }, "4 mins 10 secs")
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "text-body" }, "FCR"),
                  _createElementVNode("span", { class: "fw-medium d-block" }, "85%")
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "text-body" }, "CSAT"),
                  _createElementVNode("span", { class: "fw-medium d-block" }, "90%")
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  class: "bg-white",
                  style: {"padding":"5px !important"}
                })
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "flex-shrink-0 position-relative z-1" }, [
                      _createElementVNode("img", {
                        src: _imports_2,
                        class: "rounded-2",
                        alt: "user"
                      }),
                      _createElementVNode("span", {
                        class: "bg-danger rounded-circle d-inline-block position-absolute top-50 start-100 translate-middle",
                        style: {"width":"8px","height":"8px"}
                      })
                    ]),
                    _createElementVNode("div", { class: "flex-grow-1 ms-10" }, [
                      _createElementVNode("h4", { class: "fs-14 fw-medium mb-0" }, "Michael Brown"),
                      _createElementVNode("span", { class: "text-secondary" }, "58 Calls")
                    ])
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "text-body" }, "Avg. Call Duration"),
                  _createElementVNode("span", { class: "fw-medium d-block" }, "5 mins 20 secs")
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "text-body" }, "FCR"),
                  _createElementVNode("span", { class: "fw-medium d-block" }, "82%")
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "text-body" }, "CSAT"),
                  _createElementVNode("span", { class: "fw-medium d-block" }, "87%")
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  class: "bg-white",
                  style: {"padding":"5px !important"}
                })
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "flex-shrink-0 position-relative z-1" }, [
                      _createElementVNode("img", {
                        src: _imports_3,
                        class: "rounded-2",
                        alt: "user"
                      }),
                      _createElementVNode("span", {
                        class: "bg-success rounded-circle d-inline-block position-absolute top-50 start-100 translate-middle",
                        style: {"width":"8px","height":"8px"}
                      })
                    ]),
                    _createElementVNode("div", { class: "flex-grow-1 ms-10" }, [
                      _createElementVNode("h4", { class: "fs-14 fw-medium mb-0" }, "Emily Johnson"),
                      _createElementVNode("span", { class: "text-secondary" }, "72 Calls")
                    ])
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "text-body" }, "Avg. Call Duration"),
                  _createElementVNode("span", { class: "fw-medium d-block" }, "4 mins 30 secs")
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "text-body" }, "FCR"),
                  _createElementVNode("span", { class: "fw-medium d-block" }, "88%")
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "text-body" }, "CSAT"),
                  _createElementVNode("span", { class: "fw-medium d-block" }, "90%")
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  class: "bg-white",
                  style: {"padding":"5px !important"}
                })
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "flex-shrink-0 position-relative z-1" }, [
                      _createElementVNode("img", {
                        src: _imports_4,
                        class: "rounded-2",
                        alt: "user"
                      }),
                      _createElementVNode("span", {
                        class: "bg-danger rounded-circle d-inline-block position-absolute top-50 start-100 translate-middle",
                        style: {"width":"8px","height":"8px"}
                      })
                    ]),
                    _createElementVNode("div", { class: "flex-grow-1 ms-10" }, [
                      _createElementVNode("h4", { class: "fs-14 fw-medium mb-0" }, "David Lee"),
                      _createElementVNode("span", { class: "text-secondary" }, "53 Calls")
                    ])
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "text-body" }, "Avg. Call Duration"),
                  _createElementVNode("span", { class: "fw-medium d-block" }, "3 mins 50 secs")
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "text-body" }, "FCR"),
                  _createElementVNode("span", { class: "fw-medium d-block" }, "80%")
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "text-body" }, "CSAT"),
                  _createElementVNode("span", { class: "fw-medium d-block" }, "85%")
                ])
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}